/**
 * PRIMEIRO import do main.tsx (spec 020, FR-007): tira o token de depuração da
 * URL e o guarda na aba antes que o router leia a location e antes de qualquer
 * requisição. Módulo só de efeito — os imports são avaliados na ordem em que
 * aparecem, então ele tem de continuar sendo o primeiro.
 */
import { captureImpersonationFromLocation } from './impersonation';

captureImpersonationFromLocation();
